import { render, staticRenderFns } from "./OligoelementDialog.vue?vue&type=template&id=26be6696&scoped=true&"
import script from "./OligoelementDialog.vue?vue&type=script&lang=js&"
export * from "./OligoelementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26be6696",
  null
  
)

export default component.exports